import { AppLogo } from '@/components/common/AppLogo';
import { VendorCredit } from '@/components/common/VendorCredit';
import { LoginBackground } from './LoginBackground';
import { LoginForm } from './LoginForm';
import { APP_NAME } from '@/constants/app.constants';

export function LoginPage() {
  return (
    <div className="relative flex min-h-screen items-center justify-center bg-auth-surface px-4 py-10">
      <LoginBackground />

      <div className="relative w-full max-w-md rounded-3xl bg-card/97 px-6 pt-8 pb-8 shadow-[0_4px_16px_var(--color-auth-glow)] sm:px-10 sm:pt-11 sm:pb-10">
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-6">
            <div className="flex justify-center">
              <div className="flex size-16 items-center justify-center rounded-[18px] bg-linear-135 from-auth-tint to-border shadow-sm">
                <AppLogo className="size-8" />
              </div>
            </div>
            <div className="flex flex-col items-center gap-2 text-center">
              <h1 className="text-[26px]/6 font-semibold text-foreground">Sign in to {APP_NAME}</h1>
              <p className="text-sm text-muted-foreground">Marketing operations panel</p>
            </div>
          </div>

          <LoginForm />
        </div>

        <div className="mt-4 flex items-center gap-3">
          <span className="h-px flex-1 bg-border" />
          <span className="text-xs text-muted-foreground">SECURE ADMIN ACCESS</span>
          <span className="h-px flex-1 bg-border" />
        </div>

        <VendorCredit className="mt-6" />
      </div>
    </div>
  );
}
